import React from "react";
import { Stack } from "expo-router";
import { MobileHeader } from "@/screens/menu/mobile.header";

export default function ProfileLayout() {
  return (
    <MobileHeader>
      <Stack.Screen
        name="index"
        options={{ title: "Profile", headerShown: false }}
      />
    </MobileHeader>
  );
}
